const EditorOverlayStateEnum = {
  EDIT: 'normal',
  VIEW: 'view',
  SIGN: 'sign',
  REQUEST_SIGNATURE: 'request',
  REQUEST_SIGNATURE_WAIT: 'waiting',
  REQUEST_SIGNATURE_FILL: 'request-fill',
  SENDER_SIGNING: 'sender-signing',
  LOCKED: 'locked',
  COMPOSE_REQUEST_SIGNERS: 'compose/signers',
  COMPOSE_REQUEST_FIELDS: 'compose/fields',
  COMPOSE_REQUEST_MESSAGE: 'compose/message',
};

export const EditorOverlayActionTypes = {
  [EditorOverlayStateEnum.EDIT]: {
    type: 'ENABLE_EDIT',
    error: 'ENABLE_EDIT_ERROR',
  },
  [EditorOverlayStateEnum.VIEW]: {
    type: 'ENABLE_VIEW',
    error: 'ENABLE_VIEW_ERROR',
  },
  [EditorOverlayStateEnum.SIGN]: {
    type: 'ENABLE_SIGN',
    error: 'ENABLE_SIGN_ERROR',
  },
  [EditorOverlayStateEnum.REQUEST_SIGNATURE]: {
    type: 'ENABLE_REQUEST_SIGNATURE',
    error: 'ENABLE_REQUEST_SIGNATURE_ERROR',
  },
  [EditorOverlayStateEnum.REQUEST_SIGNATURE_WAIT]: {
    type: 'ENABLE_REQUEST_SIGNATURE_WAIT',
    error: 'ENABLE_REQUEST_SIGNATURE_WAIT_ERROR',
  },
  [EditorOverlayStateEnum.REQUEST_SIGNATURE_FILL]: {
    type: 'ENABLE_REQUEST_SIGNATURE_FILL',
    error: 'ENABLE_REQUEST_SIGNATURE_FILL_ERROR',
  },
  [EditorOverlayStateEnum.SENDER_SIGNING]: {
    type: 'ENABLE_SENDER_SIGNING',
    error: 'ENABLE_SENDER_SIGNING_ERROR',
  },
};

export default EditorOverlayStateEnum;



// WEBPACK FOOTER //
// ./src-react/EditorOverlay/EditorOverlayConstants.jsx